export const DEV_TOOLS_STORAGE_KEY = 'rvlife-profile-dev-tools';
